export default class MobileMenuComponent {
  static CLASSES = {
    MOBILE_MENU: 'mobile-menu',
    MOBILE_MENU_OPEN: 'mobile-menu--open',
    CLOSE: 'mobile-menu__header__close',
    IS_MOBILE_MENU_OPEN: 'is-mobile-menu-open',
    IS_MOBILE_MENU_CLOSING: 'is-mobile-menu-closing'
  };

  static init($mobileMenu) {
    if (!$mobileMenu || $mobileMenu.mobileMenuComponent) {
      return;
    }

    $mobileMenu.mobileMenuComponent = new MobileMenuComponent($mobileMenu);
  }

  static initAll() {
    document
      .querySelectorAll(`.${MobileMenuComponent.CLASSES.MOBILE_MENU}`)
      .forEach(($mobileMenu) => {
        MobileMenuComponent.init($mobileMenu);
      });
  }

  constructor($mobileMenu) {
    this.$mobileMenu = $mobileMenu;
    this.$close = $mobileMenu.querySelector(`.${MobileMenuComponent.CLASSES.CLOSE}`);
    this.lastPageYOffset = null;

    this.onClickClose = this.onClickClose.bind(this);

    this.init();
  }

  init() {
    this.$close.addEventListener('click', this.onClickClose);
  }

  destroy() {
    this.$close.removeEventListener('click', this.onClickClose);
    this.$mobileMenu.mobileMenuComponent = null;
  }

  onClickClose() {
    this.close();
  }

  open() {
    this.lastPageYOffset = window.pageYOffset;
    document.documentElement.classList.add(MobileMenuComponent.CLASSES.IS_MOBILE_MENU_OPEN);
    this.$mobileMenu.classList.add(MobileMenuComponent.CLASSES.MOBILE_MENU_OPEN);
    window.scrollTo(window.pageXOffset, 0);
  }

  close() {
    document.documentElement.classList.remove(MobileMenuComponent.CLASSES.IS_MOBILE_MENU_OPEN);
    document.documentElement.classList.add(MobileMenuComponent.CLASSES.IS_MOBILE_MENU_CLOSING);
    this.$mobileMenu.classList.remove(MobileMenuComponent.CLASSES.MOBILE_MENU_OPEN);
    window.scrollTo(window.pageXOffset, this.lastPageYOffset);
    document.documentElement.classList.remove(MobileMenuComponent.CLASSES.IS_MOBILE_MENU_CLOSING);
  }
}
